import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import CookieBanner from "@/components/CookieBanner";
import ScrollToTop from "@/components/ScrollToTop";
import Landing from "@/pages/Landing";
import Research from "@/pages/Research";
import ResearchDownload from "@/pages/ResearchDownload";
import Consent from "@/pages/Consent";
import FounderInfo from "@/pages/FounderInfo";
import Questionnaire from "@/pages/Questionnaire";
import Review from "@/pages/Review";
import LoadingScreen from "@/pages/LoadingScreen";
import Result from "@/pages/Result";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import ConsentText from "@/pages/ConsentText";
import TermsOfUse from "@/pages/TermsOfUse";
import DeckUpload from "@/pages/DeckUpload";
import AdminLogin from "@/pages/admin/AdminLogin";
import ChangePassword from "@/pages/admin/ChangePassword";
import AdminLayout from "@/pages/admin/AdminLayout";
import SubmissionsList from "@/pages/admin/SubmissionsList";
import SubmissionDetail from "@/pages/admin/SubmissionDetail";
import ResearchLeads from "@/pages/admin/ResearchLeads";
import ScoringProfiles from "@/pages/admin/ScoringProfiles";
import Users from "@/pages/admin/Users";
import Invites from "@/pages/admin/Invites";
import InviteRegister from "@/pages/InviteRegister";
import ResetPassword from "@/pages/ResetPassword";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Public flow */}
          <Route path="/" element={<Landing />} />
          <Route path="/research" element={<Research />} />
          <Route path="/research/download/:token" element={<ResearchDownload />} />
          <Route path="/consent" element={<Consent />} />
          <Route path="/founder" element={<FounderInfo />} />
          <Route path="/questionnaire" element={<Questionnaire />} />
          <Route path="/review" element={<Review />} />
          <Route path="/deck/:id" element={<DeckUpload />} />
          <Route path="/loading/:id" element={<LoadingScreen />} />
          <Route path="/result/:id" element={<Result />} />
          <Route path="/share/:token" element={<Result shared />} />

          {/* Legal */}
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/consent-text" element={<ConsentText />} />
          <Route path="/terms" element={<TermsOfUse />} />

          {/* Admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/change-password" element={<ChangePassword />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<SubmissionsList />} />
            <Route path="submissions/:id" element={<SubmissionDetail />} />
            <Route path="research" element={<ResearchLeads />} />
            <Route path="profiles" element={<ScoringProfiles />} />
            <Route path="users" element={<Users />} />
            <Route path="invites" element={<Invites />} />
          </Route>

          {/* Viewer invite + password reset (public) */}
          <Route path="/invite/:token" element={<InviteRegister />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
        </Routes>
      </BrowserRouter>
      <CookieBanner />
    </AuthProvider>
  );
}

export default App;
